import React from 'react';
import { motion } from 'framer-motion';
import { Section, CHECKOUT_URL, PRICE_USD, PRICE_USD_FULL, PRICE_USD_NEXT } from './Shared';
export const Pricing = () => <Section id="pricing" glow className="bg-brand-paper/70 rounded-sm my-12 border border-brand-gold/40" data-id="element-203" data-mp="2ap7z7c82fmov">
    <div className="text-center mb-10 pt-10" data-id="element-204" data-mp="2okjuplu1ph6u">
      <span className="inline-block border border-brand-gold/60 text-brand-goldDark font-seal text-[10px] md:text-xs uppercase tracking-seal px-4 py-1.5 rounded-sm mb-6" data-id="element-205" data-mp="2jkns9r0zxxte">
        Oferta de lanzamiento
      </span>
      <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-purpleDark" data-id="element-206" data-mp="1rtrmfadcstfm">
        Tu <span className="headline-shine" data-id="element-207" data-mp="25t0utnvbij91">Mega Pack Chi Kung</span>
      </h2>
      <p className="text-brand-text/70 mt-4 text-sm md:text-base" data-id="element-208" data-mp="20sv9sqjjzuzx">
        El precio de lanzamiento cierra pronto. Después sube a {PRICE_USD_NEXT}.
      </p>
    </div>

    <div className="max-w-2xl mx-auto" data-id="element-209" data-mp="3h97jhre06op5">
      <div className="relative rounded-sm" data-id="element-210" data-mp="3c78holxwvzub">
        <span className="glow-frame" aria-hidden="true" data-id="element-211" data-mp="3cae6s16jj1q1" />
        <div className="relative z-[1] w-full text-left rounded-sm p-6 md:p-8 bg-brand-paper border border-brand-purpleDark/10" data-id="element-212" data-mp="3vyf72rqt501u">
          <p className="font-seal text-[10px] uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-213" data-mp="4rb2e3i4xpwl">
            El sistema más completo
          </p>

          <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-4" data-id="element-214" data-mp="erv57alaz2gx">
            <div className="min-w-0" data-id="element-215" data-mp="3d97fjl84jsrc">
              <h3 className="font-display font-bold text-xl md:text-2xl text-brand-purpleDark leading-tight" data-id="element-216" data-mp="3daa59ptpnp5o">
                Mega Pack Chi Kung
              </h3>
              <p className="text-sm text-brand-muted mt-1.5" data-id="element-217" data-mp="3n7es7rvdronj">
                3 tomos + 6 bonus · Más de 190 páginas
              </p>
              <p className="text-sm text-brand-text/80 mt-3 max-w-sm" data-id="element-218" data-mp="3ryn3ktg9tk3c">
                El sistema integral de sesiones prediseñadas y protección
                energética para el terapeuta profesional.
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-219" data-mp="2zf7tim26n5ky">
              <p className="text-sm text-brand-muted line-through leading-none" data-id="element-220" data-mp="2rftf2huvdvit">
                {PRICE_USD_FULL}
              </p>
              <p className="font-display font-bold text-3xl md:text-4xl leading-tight mt-1.5 text-brand-purpleDark" data-id="element-221" data-mp="2mhi5m88hln14">
                {PRICE_USD}
              </p>
              <p className="text-xs text-brand-muted mt-1" data-id="element-222" data-mp="2w8mh2xyyepr7">Pago único</p>
            </div>
          </div>
        </div>
      </div>

      <motion.a href={CHECKOUT_URL} whileHover={{
      scale: 1.015
    }} whileTap={{
      scale: 0.985
    }} className="mt-6 w-full inline-flex items-center justify-center px-6 py-5 text-base md:text-lg font-semibold uppercase tracking-wide text-brand-surface purple-gradient-bg rounded-full ring-1 ring-brand-goldLight/50 animate-glow-pulse relative overflow-hidden cta-shimmer" data-id="element-223" data-mp="28i8xlvufpz88">
        <span className="relative z-10" data-id="element-224" data-mp="3tts8nxuollj7">Quiero mi Mega Pack — {PRICE_USD}</span>
      </motion.a>

      <p className="text-center text-xs md:text-sm text-brand-muted pt-5" data-id="element-225" data-mp="3ovqr5hcwlu9u">
        Garantía de 7 días · Descarga inmediata · Pago seguro · Tarjeta o PayPal
      </p>
    </div>
  </Section>;